import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';

export default function PLCapsuleChartHelp() {
    return (
        <IconTooltip>
            <div>
                Profit/Loss Capsule
                <br /> <br />
                A high-level overview of the Profit/Loss against the chosen
                benchmark (can be either Arrival, xVWAP or Last) set in the
                capsules configuration.
                <br /> <br />
                This capsule requires a single position from selected orders.
                <br /> <br />
                You can also view precise values at a specific time by
                “flipping” the Capsule (click on a the chart).
            </div>
        </IconTooltip>
    );
}
